import React from 'react';
import { User } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import BookingWidget from '../components/BookingWidget';

const Host = () => {
  const { t } = useLanguage();

  return (
    <div data-testid="host-page" className="min-h-screen pt-24 pb-32 bg-white">
      {/* Header */}
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-12 md:py-16 text-center">
        <p className="uppercase tracking-widest text-xs text-[#D4A72C] mb-4">
          Villa Aristotle
        </p>
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#1E3A5F] mb-8">
          {t('host.title')}
        </h1>

        {/* Profile Image Placeholder */}
        <div className="w-40 h-40 mx-auto mb-10 rounded-full bg-[#1E3A5F]/5 border-2 border-[#D4A72C]/30 flex items-center justify-center">
          <User className="w-16 h-16 text-[#1E3A5F]/30" />
        </div>
      </div>

      {/* Host Content */}
      <div className="max-w-2xl mx-auto px-6 md:px-12">
        <div className="text-center">
          <p className="text-[#1E3A5F]/80 text-lg leading-relaxed mb-6">
            {t('host.textPart1')}
          </p>
          <p className="text-[#1E3A5F]/80 text-lg leading-relaxed">
            {t('host.textPart2')}
          </p>
        </div>
      </div>

      {/* Sticky Mobile Booking */}
      <BookingWidget variant="sticky" />
    </div>
  );
};

export default Host;
